import api from '@/soluqr/api/client';
import { normalizeDashboardRole, ROLE_UNKNOWN } from '@/lib/dashboardPermissions';

/**
 * Misma secuencia que AuthContext: GET /business/config, y si falla o el rol
 * normalizado es unknown, GET /business/dashboard-role.
 */
export async function fetchEffectiveDashboardRole() {
  let role = ROLE_UNKNOWN;
  const silent = { _silentForbidden: true };
  try {
    const { data } = await api.get('/business/config', silent);
    role = normalizeDashboardRole(data?.dashboard_role);
  } catch {
    // Sigue unknown; intentar endpoint liviano.
  }
  if (role === ROLE_UNKNOWN) {
    try {
      const { data } = await api.get('/business/dashboard-role', silent);
      role = normalizeDashboardRole(data?.dashboard_role);
    } catch {
      role = ROLE_UNKNOWN;
    }
  }
  return role;
}

/**
 * Una sola llamada a /business/config cuando es posible; rol efectivo con el mismo fallback.
 * Útil en login / accept-invite para leer wizard_completed y no duplicar lógica.
 *
 * @returns {{ configData: object | null, role: string }}
 */
export async function fetchBusinessConfigWithEffectiveRole() {
  const silent = { _silentForbidden: true };
  let configData = null;
  try {
    const { data } = await api.get('/business/config', silent);
    configData = data ?? null;
  } catch {
    configData = null;
  }

  let role = configData
    ? normalizeDashboardRole(configData.dashboard_role)
    : ROLE_UNKNOWN;

  if (role === ROLE_UNKNOWN) {
    try {
      const { data } = await api.get('/business/dashboard-role', silent);
      role = normalizeDashboardRole(data?.dashboard_role);
    } catch {
      role = ROLE_UNKNOWN;
    }
  }

  return { configData, role };
}
